module.exports = __webpack_public_path__ + "static/media/03C.cf4becfc.png";